
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M13 21h24v12H13z"}}),_c('path',{staticClass:"i-Rectangle 16",attrs:{"stroke":"#234652","d":"M8.5 13.5h33v24h-33z"}}),_c('path',{staticClass:"i-Line 20",attrs:{"stroke":"#234652","d":"M12 11V9h27v2"}}),_c('path',{staticClass:"i-Line 21",attrs:{"stroke":"#234652","d":"M15 7V5h21v2"}})])
          )
        }
      }
    